<template>
  <vs-col
    class="p-0"
    vs-align="center"
    vs-justify="flex-end"
    vs-type="flex"
    vs-w="2.8"
  >
    <SideBar
      :active="modalOs"
      :textSucces="validacao == true ? 'Regendar servico' : 'Validar'"
      :title="'Remarcar OS N° ' + osSelecionado.id"
      :visualizar="!buttonStatus"
      size="huger"
      @hide="modalOs = false"
      @success="validacao == true ? submitForm() : verificarAgenda()"
    >
      <div
        id="remarcar"
        slot="body"
        class="w-full p-4 vs-con-loading__container"
      >
        <vs-col class="mr-10" vs-w="5">
          <div class="w-full">
            <vs-col vs-w="12">
              <Agenda class="m-4"></Agenda>
            </vs-col>
            <vs-col
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
            >
              <vs-button
                :disabled="!$atividades.permissoes.includes(12)"
                color="warning"
                type="relief"
                @click="submitForm()"
                >Agendar Sem Bloqueios
              </vs-button>
            </vs-col>
          </div>
        </vs-col>
        <vs-col vs-w="6.5">
          <vs-divider border-style="dotted" class="mt-0"
            >Reagendamento de OS
          </vs-divider>
          <vs-row class="mt-4 mx-4 mb-0" vs-type="flex" vs-w="12">
            <div
              id="head_modal_reagendar"
              class="vs-con-loading__container w-full"
            >
              <vs-col vs-w="8">
                <div class="date-with-badge">
                  <vs-input
                    v-model="os.data_remarcacao"
                    v-validate="'required'"
                    color="dark"
                    label="Data da remarcação"
                    name="data"
                    type="date"
                    class="w-full"
                    @change="removeValidacao()"
                  />
                  <div class="status-badge-wrapper date-badge-inline">
                    <div v-if="statusValidacao === null" class="status-badge badge-aguardando">
                      <i class="material-icons badge-icon">hourglass_empty</i>
                      <span class="badge-text">Aguardando validação</span>
                    </div>
                    <div v-else-if="statusValidacao === 'indisponivel'" class="status-badge badge-indisponivel">
                      <i class="material-icons badge-icon">close</i>
                      <span class="badge-text">Não há disponibilidade</span>
                      <button
                        v-if="servico.historicoFalhas && servico.historicoFalhas.length > 0"
                        class="badge-history-btn"
                        @click="popupHistoricoAtivo = true"
                      >
                        <i class="material-icons" style="font-size: 13px;">history</i>
                        Dias
                      </button>
                    </div>
                    <div v-else-if="statusValidacao === 'proximo'" class="status-badge badge-proximo">
                      <i class="material-icons badge-icon">warning</i>
                      <span class="badge-text">Data mais próxima: {{ dataProxima }}</span>
                      <button
                        v-if="servico.historicoFalhas && servico.historicoFalhas.length > 0"
                        class="badge-history-btn"
                        @click="popupHistoricoAtivo = true"
                      >
                        <i class="material-icons" style="font-size: 13px;">history</i>
                        Dias
                      </button>
                    </div>
                    <div v-else-if="statusValidacao === 'disponivel'" class="status-badge badge-disponivel">
                      <i class="material-icons badge-icon">check_circle</i>
                      <span class="badge-text">Disponível</span>
                    </div>
                  </div>
                </div>
              </vs-col>
            </div>
          </vs-row>
          <vs-row
            class="mt-4 mx-4 mb-0"
            vs-justify="flex-start"
            vs-type="flex"
            vs-w="12"
          >
            <vs-col
              vs-align="flex-start"
              vs-justify="flex-start"
              vs-type="flex"
              vs-w="4"
            >
              <div class="w-full">
                <div style="display: flex; align-items: center; justify-content: space-between; width: 200px;">
                  <label style="color: black; font-size: 13px;">
                    {{ agendarPorTurno ? 'Turno' : 'Hora Marcada' }}
                  </label>
                  <vs-switch v-model="agendarPorTurno" @input="toggleAgendamento()">
                    <span slot="on"></span>
                    <span slot="off"></span>
                  </vs-switch>
                </div>
                <div v-if="agendarPorTurno">
                  <el-select
                    v-model="os.id_turno"
                    v-validate="'required'"
                    :popper-append-to-body="false"
                    class="select-info"
                    clearable
                    filterable
                    name="turnos"
                    placeholder="Selecione..."
                    style="width: 200px"
                    @change="removeValidacao()"
                  >
                    <el-option
                      v-for="turno in turnos"
                      :key="turno.id"
                      :label="turno.nome"
                      :value="turno.id"
                      class="select-info"
                    ></el-option>
                  </el-select>
                </div>
                <div v-else>
                  <vs-input
                    v-model="os.hora_marcada"
                    v-mask="'##:00'"
                    v-validate="'required'"
                    class="inputx"
                    max="24"
                    name="hora_marcada"
                    placeholder="00:00"
                    type="datetime"
                    style="max-width: 200px;"
                    @change="removeValidacao()"
                  />
                </div>
              </div>
            </vs-col>
            <vs-col
              class="mx-3"
              vs-align="flex-end"
              vs-justify="flex-end"
              vs-type="flex"
              vs-w="2.5"
            >
              <div class="w-full">
                <vs-input
                  :value="os.carros >= 1 ? 'Carro' : 'Moto'"
                  class="inputx w-full"
                  color="success"
                  label="Veículo"
                  name="carros"
                  type="text"
                  disabled
                />
              </div>
            </vs-col>
          </vs-row>

          <vs-row
            class="mt-1 mx-5 p-0"
            vs-align="center"
            vs-justify="center"
            vs-type="flex"
            vs-w="12"
          ></vs-row>
          <vs-row class="mt-3">
            <vs-col vs-w="12">
              <div
                class="w-full p-3"
                vs-align="center"
                vs-justify="center"
                vs-type="flex"
              >
                <vs-textarea
                  v-model="os.obs"
                  v-validate="'required'"
                  class="p-0 m-0"
                  label="Motivo da alteração"
                  name="obs"
                />
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </div>
    </SideBar>

    <ModalHistoricoBuscaForca
      :ativo.sync="popupHistoricoAtivo"
      :historico="servico.historicoFalhas || []"
      :data-selecionada="servico.data"
      :disponivel="servico.disponivel"
    />
  </vs-col>
</template>

<script>
import components from "@/components/default/exports.js";
import Agenda from "@/views/pages/agenda/Agenda.vue";
import ModalHistoricoBuscaForca from "./modalHistoricoBuscaForca.vue";

export default {
  props: {
    osSelecionado: {},
    contrato: null,
  },
  data() {
    return {
      agendarPorTurno: true,
      buttonStatus: true,
      diaSelect: [1, 2, 3, 4, 5, 6, 7],
      validacao: false,
      turnos: [
        { id: 1, nome: "Manhã" },
        { id: 2, nome: "Almoço" },
        { id: 3, nome: "Tarde" },
        { id: 4, nome: "Noite" },
        { id: 5, nome: "Madrugada" },
      ],
      modalOs: false,
      popupHistoricoAtivo: false,
      statusValidacao: null,
      dataProxima: null,
      servico: { status: "Aguardando validação", obs: "Aguardando validação", historicoFalhas: [] },
      os: {
        id_turno: null,
        obs: null,
        hora_marcada: null,
        data_remarcacao: null,
        carros: 0,
        veiculo: '',
      },
    };
  },
  methods: {
    toggleAgendamento() {
      this.removeValidacao();
    },
    formatarData(data) {
      if (!data) return '';
      const parts = data.split('-');
      return parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : data;
    },
    async verificarAgenda() {
      const isTurnoValido = this.agendarPorTurno && this.os.id_turno !== null && this.os.id_turno !== '';
      const isHoraMarcadaValida = !this.agendarPorTurno && this.os.hora_marcada !== null && this.os.hora_marcada !== '';
      
      if (
        (isTurnoValido || isHoraMarcadaValida) &&
        this.os.obs != null && this.os.obs !== '' &&
        this.os.data_remarcacao != null && this.os.data_remarcacao !== ''
      ) {
        this.buttonStatus = false;
        this.validacao = null;
        const dataOriginal = this.os.data_remarcacao;
        let horasExec = null;
        let tecsExec = null;
        let inicial = false;
        this.$vs.loading({ container: "#head_modal_reagendar", scale: 0.9 });
        if (this.osSelecionado.id_tipo == 1 || this.osSelecionado.id_tipo == 3) {
          inicial = true;
          horasExec = this.contrato.horas_iniciais;
          tecsExec = this.contrato.tecnicos_iniciais;
        } else {
          horasExec = this.contrato.horas_manutencao;
          tecsExec = this.contrato.tecnicos_manutencao;
        }
        let date = this.$formartData.dataHoje();
        try {
          this.servico = await this.$http.post("verificarForca", {
            data: this.os.data_remarcacao,
            id_turno: this.agendarPorTurno ? this.os.id_turno : null,
            horaMarcada: !this.agendarPorTurno ? this.os.hora_marcada : null,
            // horasNecessarias: horasNecessarias,
            horas_exec: horasExec,
            tecnicos_exec: tecsExec,
            dias: this.diaSelect,
            inicial: inicial,
            carros: parseInt(this.os.carros) || 0,
            hoje: date,
            periodoManutencao: this.contrato.periodo_manutencao,
            datas: [],
          });
          if (this.servico.disponivel == 1) {
            if (this.servico.data === dataOriginal) {
              this.statusValidacao = 'disponivel';
            } else {
              this.statusValidacao = 'proximo';
              this.dataProxima = this.formatarData(this.servico.data);
            }
            this.os.data_remarcacao = this.servico.data;
            this.servico.color = "success";
          } else {
            this.servico.ultimaData = this.servico.data;
            this.statusValidacao = 'indisponivel';
            this.validacao = false;
            this.servico.color = "danger";
          }
          if (this.servico.historicoFalhas && this.servico.historicoFalhas.length > 0) {
            this.popupHistoricoAtivo = true;
          }
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
          if (error.code == 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
        }
        this.$vs.loading.close("#head_modal_reagendar > .con-vs-loading");
        this.verificarServicos();
        this.buttonStatus = true;
      } else {
        this.$vs.notify({
          title: "Erro",
          text: "Preencha os campos",
          color: "danger",
        });
        this.buttonStatus = true;
      }
    },
    async verificarServicos() {
      if (this.validacao != false) {
        this.validacao = true;
      }
    },
    async removeValidacao() {
      this.validacao = false;
      this.statusValidacao = null;
      this.dataProxima = null;
      this.servico = { status: "Aguardando validação", obs: "Aguardando validação", historicoFalhas: [] };
      this.popupHistoricoAtivo = false;
    },
    async osRemarcar() {
      await this.$vs.loading({ container: "#remarcar", scale: 0.6 });
      try {
        let os = {};
        os.data_remarcacao = this.os.data_remarcacao;
        os.obs = this.os.obs;
        os.remarcado = 1;
        os.confirmado = 0;
        os.hora_marcada = !this.agendarPorTurno ? this.os.hora_marcada : null;
        os.id_turno = this.agendarPorTurno ? this.os.id_turno : null;
        os.carros = this.os.carros;
        const res = await this.$http.put(
          "remarcarOs/" + this.osSelecionado.id,
          os
        );
        // let logData = {
        //   id_colaborador: localStorage.getItem("id"),
        //   funcao: "atualizar",
        //   setor: "comercial",
        //   ip: window.localStorage.getItem("ip"),
        //   texto: "Remarcação da OS N°" + res.id,
        // }
        // await this.$logger(logData)
        this.$vs.notify({
          title: "",
          text: "Reagendado com successo",
          color: "success",
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$emit("update");
      await this.$vs.loading.close("#remarcar > .con-vs-loading");
      this.modalOs = await false;
      this.obs = "";
    },
    async submitForm() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.osRemarcar();
          } else {
            this.$vs.notify({
              title: "Preencha todos os campos",
              text: "Os campos não devem ser vazios!",
              color: "danger",
            });
            reject("error");
          }
        });
      });
    },
  },
  async mounted() {
    this.modalOs = await true;
    this.agendarPorTurno = true;
    this.os = { ...this.osSelecionado };
    this.os.data_remarcacao = this.$moment(
      this.osSelecionado.data_servico
    ).format("YYYY-MM-DD");
    
    if (this.os.id_turno) {
      this.os.id_turno = Number(this.os.id_turno);
    }
  },
  components: {
    ...components,
    Agenda,
    ModalHistoricoBuscaForca,
  },
};
</script>

<style>
#status {
  border-radius: 20px !important;
}

.vs-input-success #status {
  border: 1px solid rgba(var(--vs-success), 1) !important;
}

.vs-input-danger #status {
  border: 1px solid rgba(var(--vs-danger), 1) !important;
}
.status-badge-wrapper {
  display: flex;
  align-items: center;
  margin-top: 18px;
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.badge-icon {
  font-size: 16px !important;
}
.badge-text {
  font-size: 12px;
}
.badge-aguardando {
  background-color: #fef3c7;
  color: #78350f;
}
.badge-indisponivel {
  background-color: #fee2e2;
  color: #7f1d1d;
}
.badge-proximo {
  background-color: #fed7aa;
  color: #7c2d12;
}
.badge-disponivel {
  background-color: #bbf7d0;
  color: #14532d;
}
.badge-history-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
  padding: 2px 8px;
  border: none;
  border-radius: 12px;
  background: rgba(0,0,0,0.15);
  color: inherit;
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
}
.badge-history-btn:hover {
  background: rgba(0,0,0,0.25);
}
.date-with-badge {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}
.date-badge-inline {
  flex-shrink: 0;
  margin-top: 0;
  padding-bottom: 4px;
}
</style>
